export default {
  users: [],
  archivalSpaceUsers: [],
  currentUser: {},
  pagination: {
    offset: 0,
    limit: 10,
    total: undefined,
    currentPage: undefined,
    totalPages: undefined,
  },
  safeboxUsers: [],
};
